(ns nosco.i18n.plural
  "Plural rules for all the available locales.
  Multiple libraries already implement these rules. We do not use one of them because we need to
  use the plural rules both from clojure and clojurescript.
  Also, the rules are pretty simple."
  (#?(:clj :require :cljs :require-macros) [nosco.i18n.plural-macros :as m]))

;; Some of these definitions are not used by the Clojurescript code. It is put here
;; to keep all the plural rules together.

(def one-other-plural-form
  "Needed by transifex.
  For languages that have \"one\" and \"other\" plural forms, the indexes of the plural forms in the translation seq are everything but 1."
  "(n != 1)")

(def other-plural-form
  "Needed by transifex.
  For languages that only have \"other\" plural forms, the index of the plural form in the translation seq is 0."
  "0")

(defn one-other-plural-fn
  "Returns the index, in the translations seq, of the translated form associated with the number \"n\" for languages that have \"one\" and \"other\" plural forms."
  [n]
  (if (= n 1) 0 1))

(defn other-plural-fn
  "Returns the index, in the translations seq, of the translated form associated with the number \"n\" for languages that have only \"other\" plural forms."
  [n]
  0)

(def plural-rules (m/plural-rules))

